import tmhRequest from '@/config/tmhRequest'

export default {
    searchCustomerSourceReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/customersourcereport/searchcustomersourcereportcount',
            method: 'post',
            data: data,
        })
    },
    searchCustomerSourceReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/customersourcereport/searchcustomersourcereportbypage',
            method: 'post',
            data: data,
        })
    },
    exportCustomerSourceReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/customersourcereport/exportcustomersourcereport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/customersourcereport.js